module.exports = __webpack_public_path__ + "static/media/logo-light.249112b2.svg";